import { LabelProps } from '@sitecore-jss/sitecore-jss-react-forms';
import classNames from 'classnames';

import { useFormTheme } from '../../contexts/FormTheme/FormThemeContext';

export interface RichLabelProps extends LabelProps {
  className?: string;
  richTitle?: string | TrustedHTML;
  textColor?: string;
  component?: 'label' | 'legend';
}

const JabraLabel: React.FC<RichLabelProps> = ({
  field,
  richTitle,
  textColor,
  className,
  component = 'label',
}) => {
  const { title, labelCssClass, required } = field.model;
  const labelText = title || richTitle;
  const { primaryTextColor } = useFormTheme();

  const Component = component;

  return (
    <>
      {!!labelText && (
        <div
          className={classNames(
            'relative mb-2 inline-flex text-lg font-bold',
            className,
            labelCssClass,
            textColor || primaryTextColor
          )}
        >
          <Component {...(component === 'label' ? { htmlFor: field.valueField.id } : {})}>
            {!!richTitle ? (
              <span
                className={className}
                dangerouslySetInnerHTML={{ __html: richTitle || '' }}
              ></span>
            ) : (
              title
            )}
          </Component>
          {required && (
            <span className="absolute left-full top-0 pl-0.5 font-bold text-error">*</span>
          )}
        </div>
      )}
    </>
  );
};
export default JabraLabel;
